import React, { Component } from 'react'
import Container from '../common/application_container'

export class MainRouting extends Component {
    render() {
        return (
            <Container title="Main Routing" icon="fas fa-phone">

            </Container>
        )
    }
}

export default MainRouting
